
import { defineComponent, ref, Ref } from 'vue';

export default defineComponent({
  emits: ['close', 'save', 'clear-error'],
  props: {
    error: { type: String, default: '' },
  },
  setup(props, { emit }) {
    const folderName: Ref<string> = ref('');
    function cancel() {
      emit('close');
    }

    function save() {
      if (props.error || !folderName.value.length) {
        return;
      }
      emit('save', folderName.value);
    }

    function clearValidation() {
      if (props.error) {
        emit('clear-error');
      }
    }

    return {
      folderName,
      cancel,
      save,
      clearValidation,
    };
  },
});
